import React from "react"
import { FaLongArrowAltDown } from "react-icons/fa"
import { useStaticQuery, graphql } from "gatsby"

const LangIcon = props => {
  const { language, onChange } = props

  const pdfs = useStaticQuery(graphql`
    {
      pdfs: allFile(filter: { relativeDirectory: { eq: "pdfs" } }) {
        edges {
          node {
            name
            publicURL
          }
        }
      }
    }
  `)

  const pdf = pdfs.pdfs.edges
    .map(pdf => pdf.node)
    .find(
      pdf =>
        (pdf.name === "RocaGroup_MemoriaAnual2020" && language === "es") ||
        (pdf.name === "RocaGroup_AnnualReport2020" && language === "en")
    )

  return (
    <div className="langIcon">
      <div className="langIcon-container">
        <div
          className={
            language === "en"
              ? "langIcon-container-lang unActive"
              : "langIcon-container-lang"
          }
          onClick={() => onChange()}
        >
          eng
        </div>
        <div
          className={
            language === "es"
              ? "langIcon-container-lang unActive"
              : "langIcon-container-lang"
          }
          onClick={() => onChange()}
        >
          cas
        </div>
        <a
          href={pdf.publicURL}
          target="_blank"
          className="langIcon-container-pdf-text"
        >
          <div className="langIcon-container-pdf">
            <FaLongArrowAltDown className="langIcon-container-pdf-arrow" />
            pdf
          </div>
        </a>
      </div>
    </div>
  )
}

export default LangIcon
